export const product = {
    id: '',
    name: '',
    description: '',
    isActive: false,
    uomId: '',
    uomName: '',
}